import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

interface IProps {
  rootElementId?: string;
  show: boolean;
  setShow: Function;
  conf: {
    title?: string;
    btns: Array<{
      id: 'cancel' | 'submit';
      text: string;
      callback?: Function;
    }>;
  };
  children?: any;
}

const PlaybackDialog = (props: IProps): React.ReactElement => {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    setShowDialog(props.show);
  }, [props.show]);

  return ReactDOM.createPortal(
    <>
      {showDialog &&
      <div className="cs-dialog-layer" style={{ display: showDialog ? 'block' : 'none' }}>
        <div className="cs-dialog-inner">
          {props.conf.title && <div className='cs-dialog-title'><div className='title-box'>{props.conf.title}<i className='bg'></i></div></div>}
          <div className="cs-dialog-content">{props.children}</div>
          <div className="cs-dialog-btn-group">
            {
              props.conf.btns.map(btn => {
                return <button
                  key={btn.id}
                  className={"cs-dialog-btn" + " " + (btn.id === 'cancel' ? "cancel-btn" : "submit-btn")}
                  onClick={() => { btn.callback && btn.callback() }}>{btn.text}</button>
              })
            }
          </div>
        </div>
      </div>}
    </>,
    (document.getElementById(props.rootElementId || 'homeRightContent') || document.body)
  );
}

export default PlaybackDialog;